import { render, staticRenderFns } from "./WorkflowTemplateFrom.vue?vue&type=template&id=24f51a24&scoped=true"
import script from "./WorkflowTemplateFrom.vue?vue&type=script&lang=js"
export * from "./WorkflowTemplateFrom.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTemplateFrom.vue?vue&type=style&index=0&id=24f51a24&prod&lang=less"
import style1 from "./WorkflowTemplateFrom.vue?vue&type=style&index=1&id=24f51a24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f51a24",
  null
  
)

export default component.exports